import { ActionTree } from 'vuex';
import { NavState } from './types';
import { StoreState } from '@/types';
import router from '@/router';
import billing from '@/services/billing';
import { View } from '@/models/view';

function routeRequiresAuth(route: any) {
  return route.matched.some((x: any) => x.meta.requiresAuth);
}

const actions: ActionTree<NavState, StoreState> = {
  async init({ dispatch, commit }) {
    commit('setState', 'Loading');

    router.beforeEach((to, current, next) => dispatch('beforeNavHook', { to, current, next }));
    router.afterEach((route) => dispatch('afterNavHook', route));

    // will never fail, just wait
    await dispatch('onRouterReady');

    dispatch('beforeNavHook', {
      to: router.currentRoute,
      current: router.currentRoute,
      next: (to: any) => {
        if (to) {
          commit('setState', 'Loading ' + to.name);
          router.push(to); // nav to, after nav will stop loading
        } else { commit('clearState'); } // already at route, stop loading
      },
    });
  },

  onRouterReady() {
    return new Promise<void>((resolve) => {
      // if (router.history.current.name){
      if (router.currentRoute.name) {
        return resolve();
      }
      router.onReady(() => resolve());
    });
  },

  beforeNavHook({ dispatch, commit }, { to, current, next }) {
    commit('setState', 'Loading ' + to.name);

    // if authenticated, dont go to login
    if (this.getters['auth/authenticated'] && to.name === 'login') { return next('/'); }

    // anon routes or authenticated routes continue if authenticated
    if (this.getters['auth/authenticated'] || !routeRequiresAuth(to)) { return next(); }

    // requires auth, but not authenticated and request login page, continue
    if (to.name === 'login') { return next(); }

    // deafault, redirect to login
    return next('/login' + (to.name !== 'login' ? '?return=' + to.path : ''));
  },

  // // setup after hooks to ensure initializing is false
  afterNavHook({ dispatch, commit }, route) {
    // if(!routeRequiresAuth(route) || this.getters['auth/authenticated'])
    commit('clearState');
  },

  showDialog({ commit }, v) {
    commit('showDialog', v);
  },

  newView({ commit }) {
    commit('setState', 'Loading new view');
    router.push('/pivot/new');
    // commit('clearState');
  },

  gotoView({ commit, getters, rootGetters }, name) {
    commit('setState', 'Loading ' + name);
    if (name === 'default') {
      router.push('/pivot/:view'.replace(':view', getters.defaultView));
    } else { router.push('/pivot/:view'.replace(':view', name)); }
    commit('clearState');
  },

  async deleteView({ commit, dispatch }, view: View) {
    commit('setState', 'deleting ' + view.name);
    await billing.deleteView(view);
    await dispatch('getViews', false, { root: true });
    commit('clearState');
  },

  newOrder({ commit }) {
    commit('setState', 'Loading new order');
    router.push('/order/new');
    commit('clearState');
  },

  loadOrder({ commit }, orderID) {
    commit('setState', 'Loading order ' + orderID);
    router.push('/order/' + orderID);
    commit('clearState');
  }

};

export default actions;
